import { moment } from 'utils';

const EXPIRE_AT_RANGE_TO = {
  today: 'endOfDay',
  next_6_hours: [6, 'hours'],
  next_24_hours: [24, 'hours'],
  next_week: [1, 'week'],
  next_2_weeks: [2, 'weeks'],
  next_month: [1, 'month'],
  next_3_months: [3, 'months'],
  next_6_months: [6, 'months'],
  next_year: [1, 'year'],
};

export const EXPIRE_AT_RANGE_OPTIONS = Object.keys(EXPIRE_AT_RANGE_TO);

export const USER_SORT_OPTIONS = ['expire_at', 'created_at', 'updated_at'];

export const SORT_ORDER = {
  ASC: 'asc',
  DESC: 'desc',
};

export const getExpireAtRangeBounds = (range) => {
  const toConfig = EXPIRE_AT_RANGE_TO[range];
  if (!toConfig) return null;

  return {
    from: moment(),
    to:
      toConfig === 'endOfDay'
        ? moment().endOf('day')
        : moment().add(...toConfig),
  };
};
